var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import GroupItem from "./GroupItem";
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.minQuantity = 0;
        _this.maxQuantity = null;
        /** Field **/
        _this._name = {};
        _this.groupItems = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Group.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(Group.prototype, "name", {
        get: function () {
            if (this._name && this._name.FR) {
                return this._name.FR;
            }
            return '';
        },
        set: function (value) {
            if (this._name === undefined) {
                this._name = {};
            }
            this._name.FR = value;
        },
        enumerable: false,
        configurable: true
    });
    Group.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'name') {
                        instance._name = json[prop];
                    }
                    else if (prop === 'items' || prop === 'groupItems') {
                        for (var groupItem in json[prop]) {
                            if (json[prop].hasOwnProperty(groupItem)) {
                                instance.groupItems.push(new GroupItem(json[prop][groupItem]));
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Group.prototype.exportToJson = function () {
        var Group = {};
        Group.uid = this.uid;
        Group.minQuantity = this.minQuantity;
        Group.maxQuantity = this.maxQuantity;
        Group.name = this._name;
        Group['items'] = [];
        for (var item in this.groupItems) {
            Group['items'].push(this.groupItems[item].exportToJson());
        }
        return Group;
    };
    Group.prototype.sort = function () {
        if (this.groupItems.length > 1) {
            this.groupItems.sort(function (obj1, obj2) {
                return obj1.position - obj2.position;
            });
        }
    };
    Group.prototype.add_groupItem = function (productUid) {
        var maxPosition = 0;
        for (var _i = 0, _a = this.groupItems; _i < _a.length; _i++) {
            var gi = _a[_i];
            if (maxPosition < gi.position) {
                maxPosition = gi.position;
            }
        }
        var newGroup = new GroupItem();
        newGroup.position = maxPosition + 1;
        if (!(productUid == null)) {
            newGroup.productUid = productUid;
        }
        this.groupItems.push(newGroup);
        return newGroup;
    };
    Group.prototype.addItemInNewGroupItem = function (product, instance) {
        if (instance === void 0) { instance = this; }
        var newGroupItem = new GroupItem();
        newGroupItem.productUid = product.uid;
        instance.groupItems.unshift(newGroupItem);
    };
    Group.prototype.deleteGroupItem = function (groupItem_to_delete) {
        var index = 0;
        for (var _i = 0, _a = this.groupItems; _i < _a.length; _i++) {
            var groupItem = _a[_i];
            index++;
            if (groupItem.uid === null) {
                if (groupItem.productUid === groupItem_to_delete.productUid) {
                    this.groupItems.splice(index - 1, 1);
                    break;
                }
            }
            else {
                if (groupItem_to_delete.uid === groupItem.uid) {
                    this.groupItems.splice(index - 1, 1);
                    break;
                }
            }
        }
    };
    Group.prototype.isQuantityValid = function () {
        var isValid = true;
        if (this.maxQuantity && this.minQuantity > this.maxQuantity) {
            alert("here 5");
            return false;
        }
        /** Verif GroupItem **/
        if (isValid) {
            var totalMin = 0;
            var totalMax = 0;
            var isOneItemNull = false;
            if (this.maxQuantity && this.minQuantity > this.maxQuantity) {
                alert("here 1");
                isValid = false;
            }
            if (isValid) {
                for (var _i = 0, _a = this.groupItems; _i < _a.length; _i++) {
                    var groupItem = _a[_i];
                    totalMin += groupItem.quantitySelector.minQuantity;
                    if (groupItem.quantitySelector.maxQuantity) {
                        totalMax += groupItem.quantitySelector.maxQuantity;
                    }
                    else {
                        isOneItemNull = true;
                        break;
                    }
                    for (var _b = 0, _c = groupItem.groups; _b < _c.length; _b++) {
                        var group = _c[_b];
                        if (isValid) {
                            isValid = group.isQuantityValid();
                            if (!isValid) {
                                break;
                            }
                        }
                    }
                }
                if (!isOneItemNull && totalMax < this.minQuantity) {
                    alert("here 2 " + totalMax + " " + this.minQuantity);
                    isValid = false;
                }
                if (this.maxQuantity && totalMin > this.maxQuantity) {
                    alert("here 3");
                    isValid = false;
                }
            }
        }
        return isValid;
    };
    Group.prototype.getProductUidsInGroupItem = function () {
        function searchInGroupItem(groupItem) {
            var uuids = [];
            if (groupItem.productUid) {
                uuids.push(groupItem.productUid);
            }
            if (groupItem.groups.length > 0) {
                for (var _i = 0, _a = groupItem.groups; _i < _a.length; _i++) {
                    var group = _a[_i];
                    uuids = uuids.concat(searchInGroup(group));
                }
            }
            return uuids;
        }
        function searchInGroup(group) {
            var uuids = [];
            for (var _i = 0, _a = group.groupItems; _i < _a.length; _i++) {
                var groupItem = _a[_i];
                uuids = uuids.concat(searchInGroupItem(groupItem));
            }
            return uuids;
        }
        var uuids = [];
        uuids = uuids.concat(searchInGroup(this));
        return uuids;
    };
    Group.prototype.get_max_fabricable_unities = function (products) {
        //TODO : prendre en compte la min quantity du groupItem
        if (this.groupItems.length === 0) {
            return null;
        }
        /** On veut avoir le min(maxProductable)
         * pour avoir la quantité maximale que l'on peut produire
         * **/
        var min_fabricable_product = null;
        for (var _i = 0, _a = this.groupItems; _i < _a.length; _i++) {
            var groupItem = _a[_i];
            var max_fabricable_product = groupItem.get_max_fabricable_unities(products);
            if (max_fabricable_product) {
                if (min_fabricable_product === null || max_fabricable_product < min_fabricable_product) {
                    min_fabricable_product = max_fabricable_product;
                }
            }
        }
        return min_fabricable_product;
    };
    return Group;
}(Model));
export default Group;
//# sourceMappingURL=Group.js.map